export const common = {
  'site.name': 'CSSBuy Spreadsheet',
  'site.domain': 'cssbuybr.wtf',
  'nav.home': 'Startseite',
  'nav.spreadsheet': 'Spreadsheet',
  'nav.guides': 'Guides',
  'nav.reviews': 'Bewertungen',
  'nav.shipping': 'Versand',
  'nav.coupons': 'Gutscheine',
  'nav.safety': 'Sicherheit',
  'nav.about': 'Über uns',
  'nav.contact': 'Kontakt',
  'nav.shoppingGuide': 'Einkaufsführer',
  'nav.products': 'Produkte',
  'lang.en': 'EN',
  'lang.pt': 'PT-BR',
  'lang.de': 'DE',
  'cta.explore': 'CSSBuy Spreadsheet entdecken',
  'cta.startGuide': 'Einsteiger-Guide lesen',
  'cta.readMore': 'Mehr lesen',
  'cta.viewAll': 'Alle anzeigen',
  'cta.buyNow': 'Jetzt kaufen',
  'cta.cssbuySpreadsheet': 'CSSBuy Spreadsheet',
  'cta.continueMain': 'Zur Hauptwebsite weiterleiten',
  'footer.disclaimer': 'Diese Website ist eine unabhängige Informationsquelle und steht nicht in Verbindung mit CSSBuy oder wird von CSSBuy unterstützt. Informationen können sich ändern. Überprüfen Sie vor dem Kauf immer die aktuellen Preise, Verfügbarkeit, Versandbedingungen, Richtlinien und geltenden Gesetze.',
  'footer.copyright': '© {year} CSSBuy Spreadsheet Guide. Alle Rechte vorbehalten.',
  'footer.links': 'Schnelllinks',
  'footer.legal': 'Rechtliches',
  'footer.privacy': 'Datenschutzrichtlinie',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.editorial': 'Redaktionelle Richtlinien',
  'footer.sitemap': 'Sitemap',
  'hero.eyebrow': 'CSSBUY SPREADSHEET • UNABHÄNGIGER GUIDE',
  'hero.h1': 'CSSBuy Spreadsheet – Produkte finden, vergleichen und recherchieren',
  'hero.description': 'Entdecken Sie das CSSBuy Spreadsheet, Kauf Guides, Versandinformationen, QC, Lager, Bewertungen und Vergleiche an einem Ort.',
  'hero.secondary': 'Unser Ziel ist es, Ihnen zu helfen, Produkte zu recherchieren, Kosten zu verstehen und fundiertere Entscheidungen vor dem Kauf zu treffen.',
  'hero.trust': 'Unabhängiger Guide • Aktualisierter Inhalt • English, Português & Deutsch • Fokus auf Sicherheit',
  'spreadsheet.h2': 'CSSBuy Spreadsheet: Ihr Ausgangspunkt für die Produktrecherche',
  'spreadsheet.description': 'Das CSSBuy Spreadsheet organisiert Informationen und Links, um die Produktrecherche zu erleichtern. Verwenden Sie es als Ausgangspunkt und bestätigen Sie vor dem Kauf immer aktuelle Preise, Verfügbarkeit, Verkäufer und Bedingungen.',
  'spreadsheet.card1.title': 'Finden',
  'spreadsheet.card1.desc': 'Entdecken Sie Produkte und Kategorien.',
  'spreadsheet.card2.title': 'Vergleichen',
  'spreadsheet.card2.desc': 'Vergleichen Sie Informationen vor der Entscheidung.',
  'spreadsheet.card3.title': 'Überprüfen',
  'spreadsheet.card3.desc': 'Überprüfen Sie Links, Verkäufer und QC, wenn verfügbar.',
  'spreadsheet.card4.title': 'Entscheiden',
  'spreadsheet.card4.desc': 'Bestätigen Sie aktuelle Informationen vor der Zahlung.',
  'spreadsheet.cta': 'CSSBuy Spreadsheet ansehen',
  'categories.h2': 'CSSBuy Spreadsheet nach Kategorie erkunden',
  'categories.cta': 'Alle Kategorien anzeigen',
  'beginner.h2': 'Noch nie CSSBuy genutzt? Hier starten',
  'beginner.step1': 'Finden — Produkte entdecken.',
  'beginner.step2': 'Recherchieren — Preise und Informationen vergleichen.',
  'beginner.step3': 'Überprüfen — QC, Richtlinien und Kosten analysieren.',
  'beginner.step4': 'Entscheiden — Alles vor der Zahlung bestätigen.',
  'beginner.cta': 'Einsteiger-Guide lesen',
  'review.h2': 'CSSBuy Review: lohnt es sich?',
  'review.description': 'Analysieren Sie Funktionen, Kosten, Versand, Lager, QC, Vorteile, Einschränkungen und Sicherheitspunkte vor der Entscheidung.',
  'review.card1': 'CSSBuy Review',
  'review.card2': 'CSSBuy Shipping Cost',
  'review.card3': 'CSSBuy Warehouse',
  'review.card4': 'Is CSSBuy Legit?',
  'review.card5': 'CSSBuy Coupon',
  'review.card6': 'CSSBuy Discount Code',
  'review.cta': 'Alle Bewertungen anzeigen',
  'shipping.h2': 'CSSBuy Shipping Cost: Kosten verstehen',
  'shipping.desc': 'Gewicht, Volumen, Zielort, Versandlinie, Versicherung und Zusatzleistungen können den Endpreis beeinflussen.',
  'shipping.table.factor': 'Faktor',
  'shipping.table.impact': 'Auswirkung',
  'shipping.weight': 'Gewicht',
  'shipping.weightImpact': 'Kann Kosten erhöhen',
  'shipping.volume': 'Volumen',
  'shipping.volumeImpact': 'Kann bestimmte Routen beeinflussen',
  'shipping.destination': 'Zielort',
  'shipping.destinationImpact': 'Werte variieren je nach Land',
  'shipping.line': 'Linie',
  'shipping.lineImpact': 'Tarife variieren',
  'shipping.insurance': 'Versicherung',
  'shipping.insuranceImpact': 'Kann Wert ändern',
  'shipping.services': 'Dienstleistungen',
  'shipping.servicesImpact': 'Können zusätzliche Kosten verursachen',
  'shipping.cta': 'Versandkosten-Guide ansehen',
  'safety.h2': 'Sicherheit an erster Stelle',
  'safety.card1': 'Links überprüfen',
  'safety.card2': 'Konto schützen',
  'safety.card3': 'Endpreis prüfen',
  'safety.card4': 'QC analysieren',
  'safety.card5': 'Versand verstehen',
  'safety.card6': 'Zollregeln prüfen',
  'safety.card7': 'Verdächtige Seiten meiden',
  'safety.card8': 'Keine sensiblen Daten teilen',
  'safety.cta': 'Safety Center besuchen',
  'trust.h2': 'Warum unseren Guide nutzen?',
  'trust.point1': 'Organisierte Informationen',
  'trust.point2': 'Aktualisierter Inhalt',
  'trust.point3': 'Vergleiche',
  'trust.point4': 'Mehrsprachig',
  'trust.point5': 'Unabhängig',
  'final.h2': 'Bereit, das CSSBuy Spreadsheet zu erkunden?',
  'final.desc': 'Starten Sie mit unserem Hauptguide und finden Sie Ressourcen, um Produkte zu recherchieren, Kosten zu verstehen und mit mehr Informationen zu kaufen.',
  'final.cta': 'CSSBuy Spreadsheet erkunden',
  'dropdown.label': 'Kategorien',
  'pillar.h2': 'CSSBuy Guides & Ressourcen',
  'pillar.desc': 'Entdecken Sie unsere ausführlichen Hauptartikel zu Bewertungen, Versand, Lager, QC, Gutscheinen, Sicherheit und mehr.',
  'faq.h2': 'Häufig gestellte Fragen',
  'faq.q1': 'Was ist CSSBuy Spreadsheet?',
  'faq.a1': 'Das CSSBuy Spreadsheet ist eine organisierte Sammlung von Produktlinks und Informationen, die Ihnen bei der Recherche vor dem Kauf helfen. Es dient als Ausgangspunkt für die Produktsuche und den Vergleich.',
  'faq.q2': 'Ist CSSBuy sicher zu verwenden?',
  'faq.a2': 'CSSBuy ist ein Shopping-Agent-Service. Wie bei jeder Plattform sollten Sie aktuelle Informationen überprüfen, Bewertungen lesen und Sicherheitspraktiken befolgen, bevor Sie Käufe tätigen. Bestätigen Sie immer Preise und Richtlinien vor dem Kauf.',
  'faq.q3': 'Wie verwende ich CSSBuy Spreadsheet?',
  'faq.a3': 'Verwenden Sie das Spreadsheet, um Kategorien zu durchsuchen, interessante Produkte zu finden und Informationen zu vergleichen. Überprüfen Sie immer aktuelle Links, Verkäuferinformationen und Preise direkt auf der Plattform vor dem Kauf.',
  'faq.q4': 'Was sind die CSSBuy Versandkosten?',
  'faq.a4': 'Versandkosten hängen von Gewicht, Volumen, Zielort, Versandlinie und Zusatzleistungen ab. Lesen Sie unseren Versandguide für detaillierte Informationen zu den Faktoren, die die Preise beeinflussen.',
  'faq.q5': 'Wie finde ich CSSBuy Gutscheine?',
  'faq.a5': 'Die Verfügbarkeit von Gutscheinen ändert sich häufig. Überprüfen Sie immer aktuelle Promotionen auf der offiziellen Plattform oder unseren Gutschein-Guide für die neuesten verifizierten Informationen.',
  'article.readTime': '{minutes} Min. Lesezeit',
  'article.lastUpdated': 'Zuletzt aktualisiert: {date}',
  'article.author': 'CSSBuy Guide Team',
  'article.breadcrumbHome': 'Startseite',
  'article.relatedArticles': 'Verwandte Artikel',
  'article.toc': 'Inhaltsverzeichnis',
  'article.quickAnswer': 'Schnelle Antwort',
  'article.safetyNote': 'Überprüfen Sie vor dem Kauf immer die aktuelle Plattform, Zahlungsseite, Verkäuferinformationen, Preise, Versandbedingungen und geltende Gesetze.',
  'article.sources': 'Quellen & Verifizierung',
  'seo.keywords': 'CSSBuy Spreadsheet, CSSBuy Tabelle, CSSBuy Erfahrungen, CSSBuy Versand, CSSBuy Gutschein, CSSBuy Deutschland',
  'seo.metaDescription': 'CSSBuy Spreadsheet Guide — Produkte finden, vergleichen und recherchieren. Unabhängige Bewertungen, Versandkosten, Lagerinformationen, QC-Guides, Gutscheine und Sicherheitstipps.',
  'seo.title': 'CSSBuy Spreadsheet – Produkte finden, vergleichen und recherchieren | cssbuybr.wtf',
  'category.shoes': 'Shoes',
  'category.hoodies': 'Hoodies/Sweaters',
  'category.tshirts': 'T-Shirts',
  'category.jackets': 'Jackets',
  'category.pants': 'Pants/Shorts',
  'category.headwear': 'Headwear',
  'category.sets': 'Sets',
  'category.underwear': 'Underwear/Underpants',
  'category.jersey': 'Jersey',
  'category.accessories': 'Accessories',
  'category.bags': 'Bags',
  'category.belts': 'Belts',
  'category.perfumes': 'Perfumes',
  'category.other': 'Other Stuff',
  'featuredProducts': {
    'title': 'Empfohlene Produkte',
    'subtitle': 'Stöbern Sie in kuratierten Produkten aus der CSSBuy-Tabelle — klicken Sie auf einen Artikel, um Details anzusehen und auf Kaspreadsheet zu kaufen.',
    'viewAll': 'Alle Produkte Ansehen',
  },
  'products': {
    'heroTagline': 'Kuratierte Produktauswahl',
    'heroTitle': 'CSSBuy Spreadsheet Produkte',
    'heroSubtitle': 'Durchsuchen Sie über 100 verifizierte Produkte aus der CSSBuy-Tabelle. Filtern Sie nach Kategorie, vergleichen Sie Preise und klicken Sie zum Kauf.',
    'allCategories': 'Alle Kategorien',
    'allTitle': 'Alle Produkte',
    'items': 'Artikel',
    'noResults': 'Keine Produkte in dieser Kategorie gefunden.',
    'ctaTitle': 'Bereit, mehr zu erkunden?',
    'ctaSubtitle': 'Besuchen Sie Kaspreadsheet für den vollständigen Katalog mit Tausenden weiteren verifizierten Produkten in allen Kategorien.',
  },
};

export default common;